import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';

import { title, page } from '../utils';

class HomePage extends Component {
  render() {
    const Component = page('home', this.props.rank);

    return (
      <Fragment>
        <Helmet>{title('Accueil')}</Helmet>

        <div className="home-page">
          <h1>Accueil</h1>

          <Component />
        </div>
      </Fragment>
    );
  }
}

HomePage.propTypes = {
  rank: PropTypes.number,
};

const mapStateToProps = state => {
  return {
    rank: state.user.logged ? state.user.infos.user_type.rang : 0,
  };
};

export default connect(mapStateToProps)(HomePage);
